import { ActivityClass, ActivityInClass, ActivityTypeClass, ApplyCompanyClass, ConfigClass, InsuranceClass, MessageClass } from "@/apis"
import { AuditActivityArgs, AuditApplyCompanyArgs, ChangeMessageStateArgs, CreateActivityArgs, CreateActivityTypeArgs, CreateConfigArgs, CreateInsuranceArgs, QueryActivityArgs, QueryActivityInArgs, QueryActivityTypeArgs, QueryApplyCompanyArgs, QueryInsuranceArgs, QueryMessageArgs, ReplyMessageArgs } from "@/models/args"
import { ActivityDto, ActivityInDto, ActivityTypeDto, ApplyCompanyDto, ConfigDto, InsuranceDto, MessageDto, StatCountDto, StatLineDto } from "@/models/dtos"
import { OptionsType } from "@/models/types"
import { defineStore } from "pinia"


const messageApi = new MessageClass()
const applyCompanyApi = new ApplyCompanyClass()
const activityInApi = new ActivityInClass()
const activityApi = new ActivityClass()
const insuranceApi = new InsuranceClass()
const configApi = new ConfigClass()
const activityTypeApi = new ActivityTypeClass()

export const useIndexStore = defineStore('index', {
  state: () => {
    return {
      messageTotal: 0,
      applyCompanyTotal: 0,
      activityInTotal: 0,
      activityTotal: 0,
      insuranceTotal: 0,
      configTotal: 0,
      activityTypeTotal: 0,

      activityStateOptions: <OptionsType[]>[],
      activityTypeOptions: <OptionsType[]>[],
      auditStatusOptions: <OptionsType[]>[],
      stateOptions: [{label: '是', value: 1},{label: '否', value: 0}],
      isOptions: [{label: '是', value: true},{label: '否', value: false}],
      configTypeOptions: [{label: '文本', value: 1},{label: '数值', value: 2},{label: '文本域', value: 3},{label: '开关', value: 4},{label: '上传', value: 5}],
      insuranceTypeOptions: [{label: '小程序', value: 0},{label: '公众号主页', value: 1},{label: '公众号文章', value: 2},{label: '网页', value: 3}]
    }
  },
  getters: {},
  actions: {
    getMessageList(args: QueryMessageArgs){
      return new Promise<MessageDto[]>((resolve, reject) => {
        messageApi.gets(args).then((resp) => {
          this.$patch({
            messageTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    removeMessage(id: number){
      return new Promise<number>((resolve, reject) => {
        messageApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    stateMessage(args: ChangeMessageStateArgs){
      return new Promise<number>((resolve, reject) => {
        messageApi.state(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    replyMessage(args: ReplyMessageArgs){
      return new Promise<number>((resolve, reject) => {
        messageApi.reply(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getApplyCompanyList(args: QueryApplyCompanyArgs){
      return new Promise<ApplyCompanyDto[]>((resolve, reject) => {
        applyCompanyApi.gets(args).then((resp) => {
          this.$patch({
            applyCompanyTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    exportApplyCompany(args: QueryApplyCompanyArgs){
      return new Promise<any>((resolve, reject) => {
        applyCompanyApi.excel(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    auditApplyCompany(data: AuditApplyCompanyArgs){
      return new Promise<number>((resolve, reject) => {
        applyCompanyApi.audit(data).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getActivityInList(args: QueryActivityInArgs){
      return new Promise<ActivityInDto[]>((resolve, reject) => {
        activityInApi.gets(args).then((resp) => {
          this.$patch({
            activityInTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    exportActivityInList(args: QueryActivityInArgs){
      return new Promise<Blob>((resolve, reject) => {
        activityInApi.exports(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getActivityList(args: QueryActivityArgs){
      return new Promise<ActivityDto[]>((resolve, reject) => {
        activityApi.gets(args).then((resp) => {
          this.$patch({
            activityTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createActivity(args: CreateActivityArgs){
      return new Promise<number>((resolve, reject) => {
        activityApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateActivity(args: CreateActivityArgs){
      return new Promise<number>((resolve, reject) => {
        activityApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteActivity(id: number){
      return new Promise<number>((resolve, reject) => {
        activityApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    resetActivity(id: number){
      return new Promise<number>((resolve, reject) => {
        activityApi.reset(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    auditActivity(args: AuditActivityArgs){
      return new Promise<number>((resolve, reject) => {
        activityApi.audit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    hotActivity(id: number, state: boolean){
      return new Promise<number>((resolve, reject) => {
        activityApi.hot(id, state).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    showActivity(id: number, show: boolean){
      return new Promise<number>((resolve, reject) => {
        activityApi.show(id, show).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    topActivity(id: number, top: boolean){
      return new Promise<number>((resolve, reject) => {
        activityApi.top(id, top).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    detailActivity(id: number){
      return new Promise<ActivityDto>((resolve, reject) => {
        activityApi.detail(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    statInfoActivity(){
      return new Promise<StatCountDto>((resolve, reject) => {
        activityApi.info().then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    statLineActivity(){
      return new Promise<StatLineDto[]>((resolve, reject) => {
        activityApi.line().then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getInsuranceList(args: QueryInsuranceArgs){
      return new Promise<InsuranceDto[]>((resolve, reject) => {
        insuranceApi.gets(args).then((resp) => {
          this.$patch({
            insuranceTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createInsurance(args: CreateInsuranceArgs){
      return new Promise<number>((resolve, reject) => {
        insuranceApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateInsurance(args: CreateInsuranceArgs){
      return new Promise<number>((resolve, reject) => {
        insuranceApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteInsurance(id: number){
      return new Promise<number>((resolve, reject) => {
        insuranceApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    activeInsurance(id: number, state: boolean){
      return new Promise<number>((resolve, reject) => {
        insuranceApi.active(id, state).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getConfigList(){
      return new Promise<ConfigDto[]>((resolve, reject) => {
        configApi.gets().then((resp) => {
          this.$patch({
            configTotal: resp.length
          })
          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createConfig(args: CreateConfigArgs){
      return new Promise<number>((resolve, reject) => {
        configApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateConfig(args: ConfigDto[]){
      return new Promise<number>((resolve, reject) => {
        configApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getActivityTypeList(args: QueryActivityTypeArgs){
      return new Promise<ActivityTypeDto[]>((resolve, reject) => {
        activityTypeApi.gets(args).then((resp) => {
          this.$patch({
            activityTypeTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createActivityType(args: CreateActivityTypeArgs){
      return new Promise<number>((resolve, reject) => {
        activityTypeApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateActivityType(args: CreateActivityTypeArgs){
      return new Promise<number>((resolve, reject) => {
        activityTypeApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteActivityType(id: number){
      return new Promise<number>((resolve, reject) => {
        activityTypeApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    activeActivityType(id: number, state: boolean){
      return new Promise<number>((resolve, reject) => {
        activityTypeApi.show(id, state).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
  }
})